export const maxWidth = "767px";

export const defaultBgColor = "#009EFE";
export const primaryColor = "#469EF8";
export const grayColor = "#BCC3C7";
